module.exports = __webpack_public_path__ + "d51902838f1db97ff50f7d6406a53dfb.pdf";